import React from "react";
import { Map } from "immutable";
import { MenuItem } from "@showitinc/showit-wc";
import AppConstants from "../../../constants/AppConstants";
import ContextMenuWrapper from "../../../app2components/ContextMenus/ContextMenuWrapper";
import DocumentStore from "../../../document/DocumentStore";
import { COMMANDS } from "../../../document/commands";
import UIActions from "../../../actions/UIActions";
import uiPrefix from "../../../utils/UiPrefixUtils";

const {
  CANVAS_SET_LAYER_PANEL_CANVAS_SET,
  CANVAS_SET_LAYER_PANEL_PAGE,
  CONTEXT_ITEM_BUTTON,
  ITEM_TYPE_BLOCK,
} = AppConstants;

/**
 * Context menu for a site canvas row in the canvas-set layers panel.
 *
 * @component
 * @param {Object} props
 * @param {string} props.canvasSetId - The id of the canvas set the block belongs to.
 * @param {string} props.id - The block id.
 * @param {string} props.panel - Which canvas-set panel is rendering the row.
 * @param {boolean} [props.active] - Whether the row is selected.
 */
const LayerPanelCanvasSetMenu = ({ canvasSetId, id: blockId, panel, active }) => {
  const onBlockRemove = () => {
    const data = { id: canvasSetId, blockId };
    DocumentStore.dispatch({ type: COMMANDS.REMOVE_CANVAS_FROM_CANVAS_SET, payload: data });
  };

  const onSiteCanvasEdit = () => {
    UIActions.selectSiteBlock({ block: Map({ id: blockId }) });
    UIActions.addActiveItemHistory({
      type: ITEM_TYPE_BLOCK,
    });
  };

  return (
    <ContextMenuWrapper icon="menuMoreHoriz" active={active}>
      {panel === CANVAS_SET_LAYER_PANEL_CANVAS_SET && (
        <MenuItem data-e2e={uiPrefix(`remove-${CONTEXT_ITEM_BUTTON}`)} onClick={onBlockRemove}>
          Remove
        </MenuItem>
      )}
      {(panel === CANVAS_SET_LAYER_PANEL_CANVAS_SET || panel === CANVAS_SET_LAYER_PANEL_PAGE) && (
        <MenuItem
          data-e2e={uiPrefix(`edit-site-canvas-${CONTEXT_ITEM_BUTTON}`)}
          onClick={onSiteCanvasEdit}
        >
          Edit Site Canvas
        </MenuItem>
      )}
    </ContextMenuWrapper>
  );
};

export default LayerPanelCanvasSetMenu;
